import { useContext, useEffect } from 'react';

import { client } from 'braintree-web';

import { useBraintreeGenerateTokenMutation } from '@/api/payments/braintreeGenerateToken';
import { logger } from '@/services/logger/logger';
import { useClient } from '@/services/client/useClient';
import { ProvidersLibsDispatchContext } from '@/services/providersLibs/providersLibsContext';
import { usePaymentsConfig } from '@/services/paymentsConfig/usePaymentsConfig';
import { useSelectedProvider } from '@/features/paymentSelect/useSelectedProvider';

function BraintreeLoader() {
  const providersLibsDispatch = useContext(ProvidersLibsDispatchContext);

  const { isProviderAvailable } = usePaymentsConfig();
  const { isSelectedProvider } = useSelectedProvider();

  const [braintreeGenerateTokenTrigger] = useBraintreeGenerateTokenMutation();

  const { getClientId } = useClient();

  // Generate Braintree token & load Braintree client instance on load
  useEffect(() => {
    async function loadBraintree() {
      // Only load Braintree if Braintree wallets are enabled in payments config OR if Braintree is the selected provider
      if (!isProviderAvailable('single', 'BRAINTREE_GOOGLEPAY')
        && !isProviderAvailable('single', 'BRAINTREE_APPLEPAY')
        && !isSelectedProvider('BRAINTREE')) {
        return;
      }

      const { data } = await braintreeGenerateTokenTrigger({ client: getClientId() });

      if (!data?.data?.token) {
        logger.error('Error generating Braintree token');
        return;
      }

      const braintreeToken = data.data.token;

      const braintreeClient = await client.create({
        authorization: braintreeToken,
      });

      if (!braintreeClient) {
        logger.error('Error creating Braintree client');
        return;
      }

      providersLibsDispatch({
        braintreeClient,
      });
    }
    void loadBraintree();
  }, [
    isProviderAvailable,
    isSelectedProvider,
    braintreeGenerateTokenTrigger,
    getClientId,
    providersLibsDispatch,
  ]);

  return null;
}

export default BraintreeLoader;
